export function convert(price: number): string {
  return (price / 100).toFixed(2).replace('.', ',');
}
